import React, { useState } from 'react'
import { useAuth } from '../../context/UserContext'
import StoreModal from './StoreModal'
import StoreInfo from './StoreInfo'
import { MdEdit } from 'react-icons/md'
import Summary from '../dashboard/Summary'
import { BsInfoCircleFill } from 'react-icons/bs'
import OrdersCharts from '../orders/OrdersCharts'

function DashOverView() {
    const { user, store } = useAuth()
    const [action, setAction] = useState(0)


    function openModal(val) {
        const openBtn = document.getElementById("store-open-btn")
        if (val === 0) {
            setAction(0)
        }
        if (val === 1) {
            setAction(1)
        }
        openBtn.click()
    }

    return (
        <div className='space-y-6'>
            <div className='flex flex-col md:flex-row justify-between items-center'>
                <h1 className="text-2xl font-bold text-gray-800 ">Dashboard Overview</h1>
                {store && (
                    <div className="">
                        <button
                            onClick={() => openModal(1)}
                            className="btn btn-primary btn-sm"
                        >
                            <MdEdit className="text-base" />
                            Edit Store
                        </button>
                    </div>
                )}
            </div>
            <div className='space-y-6'>
                <StoreModal
                    action={action}
                    activeStore={store}
                />
                {!store && user?.is_verified && (
                    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden border border-border-light dark:border-border-dark">
                        <div className="p-6 md:p-8">
                            <div className="border-l-4 border-info pl-4 py-4">
                                <h3 className="font-bold text-info text-lg">Add Store Details</h3>
                                <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                                    Enter info about your store to be able to add products.
                                </p>
                                <div className="pt-4">
                                    <button
                                        onClick={() => openModal(0)}
                                        className="mt-4 btn btn-primary"
                                    >
                                        Create Store
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {!user?.is_verified && (
                    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden border border-border-light dark:border-border-dark">
                        <div className="p-6 md:p-8">
                            <div className="border-l-4 border-error pl-4 py-4">
                                <h3 className="font-bold text-error text-lg">Account Verification Required</h3>
                                <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                                    To be able to create a Store and add your Products Admin Verification Is required! Contact Admin.
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                {store && (
                    <div className='space-y-6'>
                        <Summary />
                        <h1 className="text-2xl font-bold text-gray-800 flex gap-3 items-center">
                            <BsInfoCircleFill className='h-5 w-5' /> Store Info
                        </h1>
                        <div className="bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden border border-border-light dark:border-border-dark">
                            <div className="p-6">
                                <StoreInfo />
                            </div>
                        </div>
                        <OrdersCharts/>

                    </div>
                )}
            </div>
        </div>
    )
}

export default DashOverView